export enum ProfileTabEnum {
  profile = 'profile',
  leaves = 'leaves',
  logs = 'logs',
}

export const isValidProfileTab = (tab: string | null): tab is ProfileTabEnum => {
  return tab !== null && Object.values(ProfileTabEnum).includes(tab as ProfileTabEnum)
}

